/* eslint-disable */

var jsRoutes = {}

;(function (_root) {
  const setDeepObject = function (str, split = ".", obj = _root) {
    const arr = str.split(split)
    let g = obj
    for (let i = 0, len = arr.length; i < len; i++) {
      g = g[arr[i]] = g[arr[i]] || {}
    }
    return g
  }

  const queryString = function (items = []) {
    let qs = ""
    for (let i = 0; i < items.length; i++) {
      if (items[i]) qs += (qs ? "&" : "") + items[i]
    }
    return qs ? "?" + qs : ""
  }

  const query = function (r) {
    const url = `/ags${r.url}`.replace("/portal", "")

    return {
      ajax: function (options = {}) {
        options.url = url
        options.type = r.method
        return jQuery.ajax(options)
      },
      method: r.method,
      type: r.method,
      url: url,
    }
  }

  setDeepObject("controllers.LoginController")
  _root["controllers"]["LoginController"]["checkFreeLoginTicket"] = function (freeTicket0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "auth/free-login/ticket" +
        queryString([
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("freeTicket", freeTicket0),
        ]),
    })
  }
  setDeepObject("controllers.LoginController")
  _root["controllers"]["LoginController"]["freeLogin"] = function (agencyId0, userId1) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "auth/free-login/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("agencyId", agencyId0)
        ) +
        "/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("userId", userId1)
        ),
    })
  }
  setDeepObject("controllers.LoginController")
  _root["controllers"]["LoginController"]["login"] = function () {
    return query({ method: "POST", url: "/portal/" + "auth/login" })
  }
  setDeepObject("controllers.LoginController")
  _root["controllers"]["LoginController"]["sendCode"] = function () {
    return query({ method: "POST", url: "/portal/" + "auth/code" })
  }
  setDeepObject("controllers.LoginController")
  _root["controllers"]["LoginController"]["getLoginStatus"] = function () {
    return query({ method: "POST", url: "/portal/" + "auth/status" })
  }
  setDeepObject("controllers.LoginController")
  _root["controllers"]["LoginController"]["switchAgency"] = function (agencyId0) {
    return query({
      method: "POST",
      url:
        "/portal/" +
        "auth/switch/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("agencyId", agencyId0)
        ),
    })
  }
  setDeepObject("controllers.LoginController")
  _root["controllers"]["LoginController"]["getJwtToken"] = function (feature0) {
    return query({
      method: "POST",
      url:
        "/portal/" +
        "auth/iframe/token" +
        queryString([
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("feature", feature0),
        ]),
    })
  }
  setDeepObject("controllers.Fusion")
  _root["controllers"]["Fusion"]["entryMenu"] = function () {
    return query({ method: "GET", url: "/portal/" + "fusion/entry-menu" })
  }
  setDeepObject("controllers.Fusion")
  _root["controllers"]["Fusion"]["embedded"] = function (any0) {
    if (any0 == "miss") {
      return query({ method: "GET", url: "/portal/" + "embedded" })
    }

    if (true) {
      return query({
        method: "GET",
        url:
          "/portal/" +
          "embedded/" +
          (function (k, v) {
            return v
          })("any", any0),
      })
    }
  }
  setDeepObject("controllers.Fusion")
  _root["controllers"]["Fusion"]["embedded"] = function (any0) {
    if (any0 == "miss") {
      return query({ method: "GET", url: "/portal/" + "embedded" })
    }

    if (true) {
      return query({
        method: "GET",
        url:
          "/portal/" +
          "embedded/" +
          (function (k, v) {
            return v
          })("any", any0),
      })
    }
  }
  setDeepObject("controllers.UtilityController")
  _root["controllers"]["UtilityController"]["getIndustryList"] = function () {
    return query({ method: "GET", url: "/portal/" + "industry" })
  }
  setDeepObject("controllers.UtilityController")
  _root["controllers"]["UtilityController"]["getAreaList"] = function () {
    return query({ method: "GET", url: "/portal/" + "area" })
  }
  setDeepObject("controllers.UtilityController")
  _root["controllers"]["UtilityController"]["getPrivilegeList"] = function () {
    return query({ method: "GET", url: "/portal/" + "privileges" })
  }
  setDeepObject("controllers.UtilityController")
  _root["controllers"]["UtilityController"]["getPromotedObjectList"] = function () {
    return query({ method: "GET", url: "/portal/" + "promoted-object" })
  }
  setDeepObject("controllers.UtilityController")
  _root["controllers"]["UtilityController"]["getSourceTypeList"] = function () {
    return query({ method: "GET", url: "/portal/" + "source-type" })
  }
  setDeepObject("controllers.UtilityController")
  _root["controllers"]["UtilityController"]["getOpsIndustryList"] = function () {
    return query({ method: "GET", url: "/portal/" + "ops-industry" })
  }
  setDeepObject("controllers.UserController")
  _root["controllers"]["UserController"]["getUser"] = function (userId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "user/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("userId", userId0)
        ),
    })
  }
  setDeepObject("controllers.AgencyController")
  _root["controllers"]["AgencyController"]["getAgencyAccountList"] = function (platform0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "agency/get-agency-accounts" +
        queryString([
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("platform", platform0),
        ]),
    })
  }
  setDeepObject("controllers.AgencyController")
  _root["controllers"]["AgencyController"]["getManagedAgencyList"] = function () {
    return query({ method: "GET", url: "/portal/" + "agency/managed" })
  }
  setDeepObject("controllers.AgencyController")
  _root["controllers"]["AgencyController"]["searchSubAdvertiserList"] = function (agencyId0, keyword1, spid2) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "agency/sub-advertisers/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("agencyId", agencyId0)
        ) +
        queryString([
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("keyword", keyword1),
          spid2 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("spid", spid2),
        ]),
    })
  }
  setDeepObject("controllers.AgencyController")
  _root["controllers"]["AgencyController"]["getAgency"] = function (agencyId0, needAdditionalInfo1) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "agency/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("agencyId", agencyId0)
        ) +
        queryString([
          needAdditionalInfo1 == null
            ? null
            : (function (k, v) {
                return k + "=" + !!v
              })("needAdditionalInfo", needAdditionalInfo1),
        ]),
    })
  }
  setDeepObject("controllers.AgencyController")
  _root["controllers"]["AgencyController"]["getAgencyList"] = function () {
    return query({ method: "GET", url: "/portal/" + "agency" })
  }
  setDeepObject("controllers.OrganizationController")
  _root["controllers"]["OrganizationController"]["getOrganizationTree"] = function () {
    return query({ method: "GET", url: "/portal/" + "organization/tree" })
  }
  setDeepObject("controllers.OrganizationController")
  _root["controllers"]["OrganizationController"]["getTitleList"] = function () {
    return query({ method: "GET", url: "/portal/" + "organization/titles" })
  }
  setDeepObject("controllers.OrganizationController")
  _root["controllers"]["OrganizationController"]["getPositionList"] = function () {
    return query({ method: "GET", url: "/portal/" + "organization/positions" })
  }
  setDeepObject("controllers.RoleController")
  _root["controllers"]["RoleController"]["getRoleList"] = function () {
    return query({ method: "GET", url: "/portal/" + "role" })
  }
  setDeepObject("controllers.RegistrationTransferController")
  _root["controllers"]["RegistrationTransferController"]["registration"] = function () {
    return query({ method: "POST", url: "/registration/" + "transfer" })
  }
  setDeepObject("controllers.OutsideTransferController")
  _root["controllers"]["OutsideTransferController"]["outside"] = function () {
    return query({ method: "POST", url: "/outside/" + "transfer" })
  }
  setDeepObject("controllers.RoleController")
  _root["controllers"]["RoleController"]["getBoundRoleList"] = function (userId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "role/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("userId", userId0)
        ) +
        "/bound",
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getEmployeeUserList"] = function () {
    return query({ method: "GET", url: "/portal/" + "employee" })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["createEmployee"] = function () {
    return query({ method: "POST", url: "/portal/" + "employee/create" })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getSeatRoles"] = function () {
    return query({ method: "GET", url: "/portal/" + "employee/seat/roles" })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getSkillGroups"] = function (callCenterId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/seat/skill/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("callCenterId", callCenterId0)
        ),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["releaseEmployeeSeat"] = function (employeeId0) {
    return query({
      method: "POST",
      url:
        "/portal/" +
        "employee/seat/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("employeeId", employeeId0)
        ) +
        "/release",
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getEmployeeSeatInfo"] = function (employeeId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/seat/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("employeeId", employeeId0)
        ),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getEmployeePermission"] = function (employeeId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/permissions/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("employeeId", employeeId0)
        ),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["updateEmployee"] = function () {
    return query({ method: "POST", url: "/portal/" + "employee/update" })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["updateCurrentEmployeeExtensionNumber"] = function () {
    return query({ method: "POST", url: "/portal/" + "employee/update-current-employee-seat" })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["updateEmployeeStatus"] = function (employeeId0, status1, begin2, end3) {
    return query({
      method: "POST",
      url:
        "/portal/" +
        "employee/update/status" +
        queryString([
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("employeeId", employeeId0),
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("status", status1),
          begin2 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("begin", begin2),
          end3 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("end", end3),
        ]),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getCurrentEmployeeUser"] = function () {
    return query({ method: "GET", url: "/portal/" + "employee/current" })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["searchAssignableBmOperators"] = function (keyword0, qqNumber1) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/assignable-operators" +
        queryString([
          keyword0 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("keyword", keyword0),
          qqNumber1 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("qqNumber", qqNumber1),
        ]),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getManagedSubAdvertisers"] = function (qqNumber0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/sub-advertisers/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("qqNumber", qqNumber0)
        ),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getManagedBmOperators"] = function (qqNumber0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/managed-operators/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("qqNumber", qqNumber0)
        ),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["searchUidList"] = function (agencyId0, keyword1, spid2) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/search-uid-list" +
        queryString([
          agencyId0 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("agencyId", agencyId0),
          keyword1 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("keyword", keyword1),
          spid2 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("spid", spid2),
        ]),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["searchStaffList"] = function (agencyId0, keyword1, qqNumber2) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/search-staff-list" +
        queryString([
          agencyId0 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("agencyId", agencyId0),
          keyword1 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("keyword", keyword1),
          qqNumber2 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("qqNumber", qqNumber2),
        ]),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getBindUidList"] = function (agencyId0, qqNumber1, wxNumber2) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/get-bind-uid-list" +
        queryString([
          agencyId0 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("agencyId", agencyId0),
          qqNumber1 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("qqNumber", qqNumber1),
          wxNumber2 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("wxNumber", wxNumber2),
        ]),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getBindStaffList"] = function (agencyId0, qqNumber1) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/get-bind-staff-list" +
        queryString([
          agencyId0 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("agencyId", agencyId0),
          qqNumber1 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("qqNumber", qqNumber1),
        ]),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["deleteBasicOperator"] = function (id0, operatorRole1, wechatNumber2, qqNumber3) {
    return query({
      method: "POST",
      url:
        "/portal/" +
        "employee/delete-basic-operator" +
        queryString([
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("id", id0),
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("operatorRole", operatorRole1),
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("wechatNumber", wechatNumber2),
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("qqNumber", qqNumber3),
        ]),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getEmployeeUser"] = function (employeeId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("employeeId", employeeId0)
        ),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getEmployeeWorkingTeams"] = function (employeeId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/working-tree/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("employeeId", employeeId0)
        ),
    })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["batchTransferOwner"] = function () {
    return query({ method: "POST", url: "/portal/" + "employee/batch-transfer-owner" })
  }
  setDeepObject("controllers.EmployeeController")
  _root["controllers"]["EmployeeController"]["getBatchTransferDetail"] = function (oldOwnerId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "employee/get-batch-transfer-detail/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("oldOwnerId", oldOwnerId0)
        ),
    })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["search"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/search" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["searchUnassignedList"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/search-unassigned" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["searchUnregisteredList"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/search-my-ticket" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["assignReview"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/assign-review" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["batchAssign"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/batch-assign" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["registerReviewReject"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/register-review-reject" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["getRegistrationOperator"] = function () {
    return query({ method: "GET", url: "/portal/" + "registration/get-register-operators" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["register"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/gdt/register" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["updateAdvertisingInfo"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/update-advertising-info" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["registerWechatAccount"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/wechat/register" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["cancelWechatAccount"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/wechat/cancel" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["getAdvertisingInfoDetail"] = function (registrationTicketId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "registration/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("registrationTicketId", registrationTicketId0)
        ),
    })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["getRegistrationDetail"] = function (registrationTicketId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "registration/detail/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("registrationTicketId", registrationTicketId0)
        ),
    })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["getIndustryCertificationsHierarchyList"] = function (industryId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "registration/certifications/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("industryId", industryId0)
        ),
    })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["upload"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/upload" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["gdtRegistrationUpdate"] = function () {
    return query({ method: "POST", url: "/portal/" + "registration/update-gdt" })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["getRegistrationRecordList"] = function (registrationTicketId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "registration/record/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("registrationTicketId", registrationTicketId0)
        ),
    })
  }
  setDeepObject("controllers.RegistrationTicketController")
  _root["controllers"]["RegistrationTicketController"]["getAdvertisingInfo"] = function () {
    return query({ method: "GET", url: "/portal/" + "registration/account/cps-info" })
  }
  setDeepObject("controllers.CustomerController")
  _root["controllers"]["CustomerController"]["getContactList"] = function (leadId0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "customer/-/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("leadId", leadId0)
        ) +
        "/contact-list",
    })
  }
  setDeepObject("controllers.AttachmentController")
  _root["controllers"]["AttachmentController"]["upload"] = function () {
    return query({ method: "POST", url: "/portal/" + "attachment/upload" })
  }
  setDeepObject("controllers.AttachmentController")
  _root["controllers"]["AttachmentController"]["get"] = function (agencyId0, attachmentIds1) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "attachment/list/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("agencyId", agencyId0)
        ) +
        "/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("attachmentIds", attachmentIds1)
        ),
    })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["dialOutCheck"] = function () {
    return query({ method: "POST", url: "/portal/" + "call-center/dial-out/check" })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["dialOut"] = function () {
    return query({ method: "POST", url: "/portal/" + "call-center/dial-out" })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["traceCalling"] = function () {
    return query({ method: "POST", url: "/portal/" + "call-center/trace-calling" })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["getSeatInfo"] = function () {
    return query({ method: "POST", url: "/portal/" + "call-center/seat-info" })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["checkCallCenterId"] = function (agencyId0, externalId1) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "call-center/check/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("agencyId", agencyId0)
        ) +
        "/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("externalId", externalId1)
        ),
    })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["checkSeatNo"] = function (agencyId0, callCenterId1, seatNo2) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "call-center/check/seat/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("callCenterId", callCenterId1)
        ) +
        "/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("seatNo", seatNo2)
        ) +
        queryString([
          agencyId0 == null
            ? null
            : (function (k, v) {
                return encodeURIComponent(k) + "=" + encodeURIComponent(v)
              })("agencyId", agencyId0),
        ]),
    })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["checkSipPrefix"] = function (callCenterId0, sipPrefix1) {
    return query({
      method: "POST",
      url:
        "/portal/" +
        "call-center/check/sipPrefix/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("callCenterId", callCenterId0)
        ) +
        "/" +
        encodeURIComponent(
          (function (k, v) {
            return v
          })("sipPrefix", sipPrefix1)
        ),
    })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["getBlackListRecords"] = function () {
    return query({ method: "POST", url: "/portal/" + "call-center/blacklist/search" })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["checkBlackListRecord"] = function () {
    return query({ method: "POST", url: "/portal/" + "call-center/blacklist/check" })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["addBlackListRecord"] = function () {
    return query({ method: "POST", url: "/portal/" + "call-center/blacklist" })
  }
  setDeepObject("controllers.CallCenterController")
  _root["controllers"]["CallCenterController"]["batchReleaseBlackListRecord"] = function () {
    return query({ method: "DELETE", url: "/portal/" + "call-center/blacklist" })
  }
  setDeepObject("controllers.DownloadExcelController")
  _root["controllers"]["DownloadExcelController"]["downloadUserExcel"] = function () {
    return query({ method: "POST", url: "/portal/" + "admin/users/download" })
  }
  setDeepObject("controllers.DownloadExcelController")
  _root["controllers"]["DownloadExcelController"]["queryDownloadResult"] = function (uuid0) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "download/result" +
        queryString([
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("uuid", uuid0),
        ]),
    })
  }
  setDeepObject("controllers.Assets")
  _root["controllers"]["Assets"]["at"] = function (file1) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "static/" +
        (function (k, v) {
          return v
        })("file", file1),
    })
  }
  setDeepObject("controllers.defaults.Auth")
  _root["controllers"]["defaults"]["Auth"]["getLoginStatus"] = function () {
    if (true) {
      return query({ method: "POST", url: "/portal/" + "auth/status" })
    }
  }
  setDeepObject("controllers.defaults.Auth")
  _root["controllers"]["defaults"]["Auth"]["getLoginStatus"] = function () {
    if (true) {
      return query({ method: "POST", url: "/portal/" + "auth/status" })
    }
  }
  setDeepObject("controllers.defaults.Auth")
  _root["controllers"]["defaults"]["Auth"]["logout"] = function () {
    if (true) {
      return query({ method: "POST", url: "/portal/" + "auth/logout" })
    }
  }
  setDeepObject("controllers.defaults.Auth")
  _root["controllers"]["defaults"]["Auth"]["logout"] = function () {
    if (true) {
      return query({ method: "POST", url: "/portal/" + "auth/logout" })
    }
  }
  setDeepObject("controllers.ActivityController")
  _root["controllers"]["ActivityController"]["searchList"] = function (leadId, pageSize, pageIndex) {
    return query({
      method: "GET",
      url:
        "/portal/" +
        "activity/searchList" +
        queryString([
          (function (k, v) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(v)
          })("leadId", leadId),
          (function (k, v) {
            return `${k}=${v}`
          })("pageSize", pageSize),
          (function (k, v) {
            return `${k}=${v}`
          })("pageIndex", pageIndex),
        ]),
    })
  }
})(jsRoutes)

export default jsRoutes
